import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

export const Route = createFileRoute(
  "/_staff/profile/device/$id/_profile/monitoring",
)({
  component: () => <ComingSoonCover />,
});
